import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { type ProximityDriveTimePathsState } from '~/store/frontendState/proximityDriveTimePaths/proximityDriveTimePaths.state';
import {
  isDriveTimePolygonSettings, isGroupRadius, isIndividualRadius, type Proximity, type ProximityModel,
} from '../_shared/types/proximity/proximity.types';
import {
  driveTimeMessagesSelector,
  driveTimePathsSelector,
} from '../store/frontendState/proximityDriveTimePaths/proximityDriveTime.selectors';
import { getDriveTimePathsPathId } from '../store/frontendState/proximityDriveTimePaths/proximityDriveTimePaths.helpers';
import { proximitiesSelector } from '../store/mapSettings/proximity/mapSettingsProximity.selectors';

export const proximityListSelector = createStateSelector([
  proximitiesSelector,
  driveTimePathsSelector,
  driveTimeMessagesSelector,
], (proximitiesState, driveTimeData, driveTimeMessages): ReadonlyArray<Proximity> => {
  const proximities = combineProximities(proximitiesState, driveTimeData, driveTimeMessages);
  return proximities;
});
export const useProximities = () => useSelector(proximityListSelector);

const combineProximities = (
  proximitiesState: ReadonlyArray<ProximityModel>,
  driveTimeData: ProximityDriveTimePathsState['paths'],
  driveTimeMessages: ProximityDriveTimePathsState['messages'],
): ReadonlyArray<Proximity> => {
  const results: Proximity[] = [];

  proximitiesState.forEach(item => {
    if (isIndividualRadius(item) || isGroupRadius(item)) {
      results.push(item);
    }

    if (isDriveTimePolygonSettings(item)) {
      const Id = getDriveTimePathsPathId({
        latLng: {
          lat: item.data.lat,
          lng: item.data.lng,
        },
        minutes: item.data.minutes,
        hours: item.data.hours,
      });
      const paths = driveTimeData[Id];
      const message = driveTimeMessages[Id];

      results.push({
        ...item,
        data: {
          ...item.data,
          message,
          paths,
        },
      });
    }
  });

  return results;
};
